import {type ButtonStyleProps, ButtonVariant, ButtonSize} from './button.types'

// For use when we need to build a custom button implementation
// that is not standard, But we still want it to look like
// a standard button.
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export function getButtonStyleProps<T extends ButtonStyleProps>(props: T): ButtonStyleProps {
    return {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        variant: props?.variant ?? ButtonVariant.Solid,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        size: props?.size ?? ButtonSize.MD,
    }
}
